import { css, html, LitElement } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { property } from "lit/decorators/property.js";

export type SEOTitleLevel = 1 | 2 | 3 | 4 | 5 | 6;
export const DEFAULT_SEO_TITLE_LEVEL: SEOTitleLevel = 2;

@customElement("bs-seo-title")
export class BsSEOTitle extends LitElement {
	@property({ type: Number }) level: SEOTitleLevel = DEFAULT_SEO_TITLE_LEVEL;

	static get styles() {
		return [
			css`
				h1,
				h2,
				h3,
				h4,
				h5,
				h6 {
					all: unset;
					display: contents;
				}
			`
		];
	}

	render() {
		switch (this.level) {
			case 1:
				return html`<h1><slot></slot></h1>`;
			case 2:
				return html`<h2><slot></slot></h2>`;
			case 3:
				return html`<h3><slot></slot></h3>`;
			case 4:
				return html`<h4><slot></slot></h4>`;
			case 5:
				return html`<h5><slot></slot></h5>`;
			case 6:
			default:
				return html`<h6><slot></slot></h6>`;
		}
	}
}
